import React from 'react'
import { useParams } from 'react-router-dom'
import './TaskViews.scss'

interface AreaViewProps {
  lifeSpace?: 'personal' | 'work' | 'home' | 'all'
  /** When rendered through TabStack, the area name is extracted from the
   *  tab path and passed directly. Falls back to useParams for Route-based
   *  callers. */
  areaName?: string
}

export const AreaView: React.FC<AreaViewProps> = ({ areaName: areaNameProp }) => {
  const { areaName: areaNameParam } = useParams<{ areaName: string }>()
  const areaName = areaNameProp ?? areaNameParam

  const title = areaName
    ? areaName.replace(/-/g, ' ')
    : 'Bereich'

  return (
    <div className="task-view">
      <div className="task-view__header">
        <div className="task-view__title-section">
          <h2 className="task-view__title">{title}</h2>
        </div>
      </div>
    </div>
  )
}
